// Bootstrap Framework
import './scss/index.scss';

import jquery from 'jquery';
window.$ = window.jQuery = jquery;

import 'popper.js';
import 'bootstrap';

import 'jquery-match-height';
import Sticky from "sticky-js";

$(function () {

    $('[data-toggle="tooltip"]').tooltip();

    //#region sticky navbar
    let stickyNavbar = new Sticky(".navbar");
    //#endregion

});
